export const cssSwitchButtons = [
  {
    key: 'HAND',
    name: 'Конструктор',
  },
  {
    key: 'CSS',
    name: 'CSS',
  },
];